import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { dropSeoFallbackTags } from "@/lib/seoFallback";

// Fallback <head> tagovi iz index.html postoje samo dok se aplikacija ne podigne.
// Moraju da odu pre prvog render-a, inače stoje kao duplikati pored tagova
// koje ubacuje <Seo>.
dropSeoFallbackTags();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
